module.exports = {"TXTWCL_Payee":{"id":"TXTWCL_Payee","defaultMessage":"Kedvezményezett"}}